<template>
  <a-card :bordered="false">
    <div>
      <!-- 查询区域 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline" @keyup.enter.native="searchQuery">
          <a-row :gutter="24">
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="选择渠道">
                <a-select
                  show-search
                  placeholder="请选择渠道"
                  option-filter-prop="children"
                  :filter-option="filterOption"
                  :default-value="wechatApp[0]"
                  v-model="queryParam.appId"
                  @change="handleChange"
                  id="aa"
                >
                  <a-select-option
                    v-for="item in wechatApp"
                    :key="item.appId"
                    :value="item.appId"
                    >{{ item.name }}</a-select-option
                  >
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 查询区域-END -->
      <a-tabs v-model="activeKey" @tab-click="handleTabClick">
        <a-tab-pane tab="图片素材" key="1" lazy>
          <material-file
            fileType="image"
            ref="imagePanel"
            @change="materialCount"
          ></material-file>
        </a-tab-pane>
      </a-tabs>
    </div>
  </a-card>
</template>
<script>
import { getAction } from '@/api/manage';
export default {
  data() {
    return {
      appId: '',
      activeKey: '1',
      queryParam: {
        appId: '',
      },
      imageBatch: [],
      assetsCount: {
        imageCount: '..',
        videoCount: '..',
        voiceCount: '..',
        newsCount: '..',
      },
      wechatApp: [],
    };
  },
  components: {
    MaterialFile: () => import('./material-file'),
  },
  mounted() {
    this.getWechatApp();
  },
  methods: {
    handleChange(value) {
      this.queryParam.appId = value;
      this.materialCount();
      this.$refs.imagePanel.getFileBatch(this.queryParam.appId);
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    handleTabClick(tab, event) {
      this.$nextTick(() => {
        this.$refs[tab.name + 'Panel'].init();
      });
    },
    getWechatApp() {
      getAction(process.env.VUE_APP_CMS_WECHAT + '/wechatApp/queryByType', {
        type: '1,2,3',
      }).then((res) => {
        if (res.success) {
          this.queryParam.appId = res.result[0].appId;
          this.appId = res.result[0].appId;
          this.wechatApp = res.result;
          this.materialCount();
          this.$refs.imagePanel.getFileBatch(this.queryParam.appId);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    materialCount() {
      getAction(
        process.env.VUE_APP_CMS_WECHAT + `/wechat/material/materialCount`,
        { appId: this.queryParam.appId }
      ).then((res) => {
        if (res.success && res.code == 200) {
          this.assetsCount = res.result;
        } else {
          // this.$message.error(res.message);
        }
      });
    },
  },
};
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
